export const settings = {
  apiURL: "https://customzonpod.com/mayaUp",
  siteName: "CUSTOMZON POD",
  siteUrl: "https://www.customzonpod.com",
  email: "info@customozon.com",
  phone: "+1 (512)-800-4655",
  address: "7696 183A Toll Rd. Building 1 Suite F, Leander, TX, 78641",
};
